export default "__VITE_ASSET__CGtSUL3y__"